<mat-card>
  <mat-card-title>{{titleSearch}}</mat-card-title>
  <mat-card-subtitle>{{parentLabel}}</mat-card-subtitle>
  <mat-card-actions align="end">
    <button mat-button [disabled]="! canSelect()" (click)="select()">Choisir</button>
    <button *ngIf="dialogRef" mat-button (click)="close()">Fermer</button>
  </mat-card-actions>
  <mat-card-content>
    <mat-card>
      <div>
        <mat-form-field fxFlex="90" appearance="outline">
          <input matInput [matAutocomplete]="auto"
                 placeholder="{{placeholder}}"
                 matTooltip="{{tooltip}}"
                 aria-label="DirCmp"
                 [formControl]="entiteForm">
          <mat-icon matSuffix>search</mat-icon>
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let entite of entitesResults | async"
                        [value]="entite.name"
                        (onSelectionChange)="onSearchSelectEntite(entite)">
              <span>{{getDisplayEntite(entite)}}</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <mat-card-content>
        <mat-select placeholder="ou je choisis ma DIRECTION ou COMPOSANTE dans la liste" (selectionChange)="onSelectEntite($event)">
          <mat-option *ngFor="let entite of listEntites" [value]="entite">
            {{getDisplayEntite(entite)}}
          </mat-option>
        </mat-select>
      </mat-card-content>
    </mat-card>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-button [disabled]="! canSelect()" (click)="select()">Choisir</button>
    <button mat-button (click)="close()">Fermer</button>
  </mat-card-actions>
  <mat-card-footer>
  </mat-card-footer>
</mat-card>

